import React, { useEffect, useState } from "react";
import { Box, Container, IconButton, Typography } from "@mui/material";
import { eagle_icon_white, eaglewhite } from "../../assets/images";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import PhoneIcon from "@mui/icons-material/PhoneRounded";
import MessageIcon from "@mui/icons-material/Mail";
import LocationIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import { collection, db, getDocs } from "../../firebaseConfig";
import dayjs from "dayjs";

const Footer = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);

  // Fetch data from Firestore when the component loads
  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "articles"));
      const articleList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setArticles(articleList);
    };

    fetchData();
  }, []);
  const footerLinks = [
    {
      id: 1,
      label: "Home",
      link: "/",
    },
    {
      id: 2,
      label: "About",
      link: "/about",
    },
    {
      id: 3,
      label: "Our sites",
      link: "/sites",
    },
    {
      id: 4,
      label: "News",
      link: "/news",
    },
    {
      id: 5,
      label: "FAQ",
      link: "/faq",
    },
    {
      id: 6,
      label: "Donate",
      link: "/journey",
    },
  ];

  const contactInfo = [
    {
      id: 1,
      contact: "+263 78 494 8094",
      icon: <PhoneIcon sx={{ color: "#ffffff" }} />,
    },
    {
      id: 1,
      contact: "info@eaglelearning.org",
      icon: <MessageIcon sx={{ color: "#ffffff" }} />,
    },
    {
      id: 1,
      contact: "23 Smith Avenue Queenspark West, Bulawayo, Zimbabwe",
      icon: <LocationIcon sx={{ color: "#ffffff" }} />,
    },
  ];

  const socialLinks = [
    {
      id: 1,
      icon: <FacebookIcon color="secondary" />,
      link: "https://www.facebook.com/learn.eagle",
    },
    {
      id: 2,
      icon: <LinkedInIcon color="secondary" />,
      link: "https://www.facebook.com/learn.eagle",
    },
    {
      id: 3,
      icon: <InstagramIcon color="secondary" />,
      link: "https://www.facebook.com/learn.eagle",
    },
  ];

  const convertFirebaseTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "Invalid Date";
    return dayjs.unix(timestamp.seconds).format("MMMM D, YYYY");
  };

  return (
    <Box
      sx={{ width: "100vw", height: "50vh", backgroundColor: "primary.main" }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: { sx: "column", md: "row" },
          justifyContent: { xs: "center", md: "space-between" },
          alignItems: "center",
          height: "inherit",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: 300 },
            height: { xs: "100%", md: "80%" },
            display: "flex",
            flexDirection: "column",
            justifyContent: { xs: "center", md: "flex-start" },
            alignItems: {
              xs: "center",
              md: "flex-start",
              textAlign: { xs: "center", md: "start" },
            },
          }}
        >
          <img src={eaglewhite} alt="eagle learning logo" width={120} />
          <Typography
            variant="body1"
            color="primary.dark"
            sx={{
              textAlign: { xs: "center", md: "start" },
              my: { xs: 1, md: 0 },
            }}
          >
            Providing enhanced access to great learning experiences
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: 200,
              justifyContent: { xs: "center", md: "flex-start" },
              my: 2.5,
            }}
          >
            {socialLinks.map((social) => (
              <IconButton
                aria-label="delete"
                sx={{ backgroundColor: "primary.dark", mr: 1 }}
                onClick={() => (window.location.href = `${social.link}`)}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Box>

        {/* Explore footer section */}
        <Box sx={{ height: "70%", display: { xs: "none", md: "block" } }}>
          <Typography variant="h6" color="primary.dark">
            Explore
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", mt: 1 }}>
            <hr
              style={{
                width: 50,
                borderStyle: "none",
                border: "2px solid #222222",
                borderRadius: 100,
              }}
            />
            <hr
              style={{
                width: 2,
                borderStyle: "none",
                border: "2px solid #222222",
                borderRadius: 100,
                marginLeft: 2,
              }}
            />
          </Box>
          {footerLinks.map((footer) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                my: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => navigate(footer.link)}
            >
              <img
                src={eagle_icon_white}
                width={15}
                height={13.33}
                alt="eagle learning logo white"
              />
              <Typography
                variant="body1"
                color="primary.dark"
                sx={{ ml: 1, ":hover": { color: "#222222" } }}
              >
                {footer.label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* News footer section */}
        <Box
          sx={{
            maxWidth: 230,
            height: "70%",
            display: { xs: "none", md: "block" },
          }}
        >
          <Typography variant="h6" color="primary.dark">
            News
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", mt: 1 }}>
            <hr
              style={{
                width: 50,
                borderStyle: "none",
                border: "2px solid #222222",
                borderRadius: 100,
              }}
            />
            <hr
              style={{
                width: 2,
                borderStyle: "none",
                border: "2px solid #222222",
                borderRadius: 100,
                marginLeft: 2,
              }}
            />
          </Box>
          {articles.slice(0, 2).map((news) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                mt: 2,
                mb: 4,
              }}
            >
              <Typography
                variant="h7"
                color="primary.dark"
                sx={{ textTransform: "none" }}
              >
                {news.title}
              </Typography>
              <Typography variant="body1" color="secondary">
                {convertFirebaseTimestamp(news.createdAt)}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Contact footer section */}
        <Box sx={{ height: "70%", display: { xs: "none", md: "block" } }}>
          <Typography variant="h6" color="primary.dark">
            Contact
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", mt: 1 }}>
            <hr
              style={{
                width: 50,
                borderStyle: "none",
                border: "2px solid #222222",
                borderRadius: 100,
              }}
            />
            <hr
              style={{
                width: 2,
                borderStyle: "none",
                border: "2px solid #222222",
                borderRadius: 100,
                marginLeft: 2,
              }}
            />
          </Box>
          {contactInfo.map((contact) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                my: 2,
                alignItems: "center",
              }}
            >
              {contact.icon}
              <Typography
                variant="body1"
                color="primary.dark"
                sx={{ ml: 1, maxWidth: 200 }}
              >
                {contact.contact}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
